import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll';

import './contato.css'
import { IoIosChatbubbles, IoIosVideocam, IoIosBriefcase, IoLogoWhatsapp, IoIosMailOpen, IoIosCalendar, IoIosTime, IoIosTv, IoIosCard, IoLogoYoutube } from 'react-icons/io';

import contatoImg from '../../assets/contato-img.JPG';
// import selo from '../../assets/selo.png'
import pt from "../../locales/pt.json";

const Contato = () => {
  const whatsappLink = 'https://api.whatsapp.com/send?phone=5511943421608&text=Oi,%20vi%20o%20seu%20site%20pelo%20Google%20e%20tenho%20interesse%20em%20come%C3%A7ar%20o%20processo%20terap%C3%AAutico.%20Como%20podemos%20dar%20o%20primeiro%20passo%3F';

  return (
    <div className="psico__contato contato__padding" id="contato">
      <AnimationOnScroll animateIn="fade-in-bottom" duration={1}>
        <div className="psico__contato-left">
          <div className="psico__contato-left__title">
            {/* <h4>Clínica André Parreira Psicologia</h4> */}
            <h4>{pt.contato.title}</h4>
            {/* <p>Pronto para transformar a sua vida?</p> */}
          </div>

          <div className="psico__contato-left__img">
            <img src={contatoImg} alt="Escritório de atendimento." />
          </div>

          <div className="selo__container">
            <div className="psico__contato-left__info">
              <div className="contato-infos-container">
                <div className="icon-container">
                  <IoIosChatbubbles />
                </div>
                <p>{pt.contato.online}</p>
              </div>

              <div className="contato-infos-container">
                <div className="icon-container">
                  <IoIosVideocam />
                </div>
                <p>{pt.contato.meet}</p>
              </div>

              <div className="contato-infos-container">
                <div className="icon-container">
                  <IoIosBriefcase />
                </div>
                <p>{pt.contato.crp}</p>
              </div>
            </div>
            {/* <div className="contato-selo">
              <img src={selo} alt="Selo de qualidade" />
            </div> */}
          </div>
        </div>
      </AnimationOnScroll>

      <AnimationOnScroll animateIn="fade-in-bottom" duration={1}>
        <div className="psico__contato-right">
          <div className="psico__contato-right__contatos">
            <h4>{pt.contato.contatos}</h4>

            <div className="whats-link">
              <div className="contato-infos-container">
                <div className="icon-container">
                  <IoLogoWhatsapp />
                </div>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                  <p>{pt.contato.zap}</p>
                </a>
              </div>
            </div>

            <div className="contato-infos-container" id="emailFull">
              <div className="icon-container">
                <IoIosMailOpen />
              </div>
              <a href="mailto:psi.andreparreira@gmail.com">{pt.contato.email}</a>
            </div>


            <div className="contato-infos-container" id="emailBroken">
              <div className="icon-container">
                <IoIosMailOpen />
              </div>
              <div className="email-broken">
                <p><a href="mailto:psi.andreparreira@gmail.com">{pt.contato.emailBroken1}</a></p><br />
                <p><a href="mailto:psi.andreparreira@gmail.com">{pt.contato.emailBroken2}</a></p>
              </div>
            </div>

            <div className="youtube-link">
              <div className="contato-infos-container">
                <div className="icon-container">
                  <IoLogoYoutube />
                </div>
                <a href="https://www.youtube.com/channel/UCjGF1h3fXsuQqPH1FSiXDcQ" target="_blank" rel="noopener noreferrer">
                  <p>{pt.contato.youtube}</p>
                </a>
              </div>
            </div>
          </div>

          <div className="psico__contato-right__horarios">
            <h4>Horários de Atendimento</h4>

            <div className="contato-infos-container">
              <div className="icon-container">
                <IoIosCalendar />
              </div>
              <p>Segunda a Sexta | Sábado</p>
            </div>

            <div className="contato-infos-container">
              <div className="icon-container">
                <IoIosTime />
              </div>
              <p>08h00 às 22h00&nbsp;&nbsp;| 08h00 às 12h00</p>
            </div>

            <div className="contato-infos-container">
              <div className="icon-container">
                <IoIosTv />
              </div>
              <p>Atendimento On-line</p>
            </div>


          </div>

          <div className="psico__contato-right__reembolso">
            <h4>{pt.contato.reembolso}</h4>

            <div className="contato-infos-container">
              <div className="icon-container">
                <IoIosCard />
              </div>
              <p>
                {pt.contato.duvidas}
              </p>
            </div>

          </div>
        </div>
      </AnimationOnScroll>
    </div>
  )
}

export default Contato
